import swal from '@sweetalert/with-react';
import { renderLoginPopup } from '../../../logic/api';

// userRights stammt aus der Login-Antwort (userdata, wie in logic/userRights.js).
// Die Middleware lehnt Speichern und Loeschen fuer das Recht "Auswertung" ab.
const READ_ONLY_RIGHT = 'Auswertung';

export const canEditClinics = (userContext) => {
  if (!userContext || !userContext.isElevatedUser) return false;
  const userRights = userContext.userdata?.userRights || [];
  return !userRights.includes(READ_ONLY_RIGHT);
};

export const SAVE_ERROR_TEXT =
  'Die Klinik wurde nicht gespeichert. Bitte versuchen Sie es später erneut; Ihre Eingaben bleiben im Formular erhalten.';

export const DELETE_ERROR_TEXT =
  'Die Klinik wurde nicht gelöscht. Bitte versuchen Sie es später erneut.';

// 401 kommt auch bei abgelaufener Sitzung. Wie logic/api.js den Login-Dialog
// oeffnen: er liegt ueber der Seite, die Eingaben bleiben erhalten und der
// Nutzer kann nach der Anmeldung erneut speichern.
export const reportClinicRequestError = (error, title, text) => {
  if (error?.status === 401) {
    renderLoginPopup();
    return;
  }
  swal({ title, text, icon: 'error' });
};
